import { useState } from 'react';

interface ExpandableTextareaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  previewMaxLines?: number;
  className?: string;
  actions?: React.ReactNode;
  emptyText?: string;
}

export function ExpandableTextarea({
  label,
  value,
  onChange,
  placeholder,
  rows = 10,
  previewMaxLines = 5,
  className = '',
  actions,
  emptyText = '(未設定)',
}: ExpandableTextareaProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const truncateText = (text: string): string => {
    const lines = text.split('\n');
    if (lines.length <= previewMaxLines) return text;
    return lines.slice(0, previewMaxLines).join('\n') + '\n...';
  };

  return (
    <div className="card p-4">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
          {label}
        </label>
        <div className="flex items-center gap-2">
          {actions}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-xs text-primary-600 dark:text-primary-400 hover:underline"
          >
            {isExpanded ? '收合' : '展開'}
          </button>
        </div>
      </div>
      {isExpanded ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          className={`textarea w-full ${className}`}
        />
      ) : (
        <pre className="p-3 bg-neutral-100 dark:bg-neutral-700 rounded text-xs font-mono text-neutral-600 dark:text-neutral-300 overflow-hidden max-h-32">
          {value ? truncateText(value) : emptyText}
        </pre>
      )}
    </div>
  );
}
